import {Component} from "@angular/core";
import {SESSION_DATA} from "../renderer/model/dictionary";

@Component({
    selector: "data-history",
    templateUrl: './data.history.component.html'
})
export class DataHistoryComponent {

    getSubmittedDataHistory(): string {
        return sessionStorage.getItem(SESSION_DATA);
    }

    getRows(): number {
        return this.getSubmittedDataHistory().split("\n").length;
    }

}
